<template>
  <div class="user-list-detail">
    <div class="user-list-detail__header">
      <div class="user-list-detail__about-container">
        <div class="user-list-detail__userpic-container">
          <avatar :upic="user.getUpic()"
                  :name="user.getLastName()"
                  size="small">
          </avatar>
        </div>
        <div class="user-list-detail__about-text-container">
          <div class="user-list-detail__names">
            {{user.getFullName()}}
          </div>
        </div>
      </div>
      <div class="user-list-detail__buttons">
        <router-link class="el-button" :to="{ name: 'userEdit', params: { id: user.getId() } }">{{ $t('labels.edit') }}</router-link>
        <router-link class="el-button el-button--primary" :to="{ name: 'user', params: { id: user.getId() } }">{{ $t('labels.more') }}</router-link>
      </div>
    </div>
    <div v-if="hasContacts() || user.getOrgs().length" class="user-list-detail__profile-section">
      <div v-if="hasContacts()" class="user-detail-info-block">
        <div class="user-detail-info-block__label">
          {{ $t('labels.contacts') }}
        </div>
        <div v-for="(contact, index) in user.getContacts()" :key="index" class="user-detail-info-block__row">
          <div class="user-detail-info-block__row-label">
            {{contact.type}}
          </div>
          <div class="user-detail-info-block__row-data">
            {{contact.value}}
          </div>
        </div>
      </div>
      <!-- <template v-if="user.orgs && Array.isArray(user.orgs)">
        <div v-for="(place, index) in user.orgs" :key="index"
             class="user-detail-info-block">
          <div class="user-detail-info-block__label">
            {{ $t('labels.work_place') }}
          </div>
          <div class="user-detail-info-block__row">
            <div class="user-detail-info-block__row-label">
              {{ $t('labels.place') }}
            </div>
            <div class="user-detail-info-block__row-data">
              <dep-name :orgId="place.org_id" :showParent="true"></dep-name>
            </div>
          </div>
          <div class="user-detail-info-block__row">
            <div class="user-detail-info-block__row-label">
              {{ $t('labels.position') }}
            </div>
            <div class="user-detail-info-block__row-data">
              <posts-in-row :posts="place.posts"></posts-in-row>
            </div>
          </div>
          <div class="user-detail-info-block__row">
            <div class="user-detail-info-block__row-label">
              Роль
            </div>
            <div class="user-detail-info-block__row-data">
              <roles-name :roles="place.roles"></roles-name>
            </div>
          </div>
        </div>
      </template> -->
    </div>
  </div>
</template>

<script>
  import avatar from 'src/components/Avatar/avatar.vue'
  import superAdminIdent from 'src/components/SuperAdminIdent/SuperAdminIdent.vue'
  // import depName from 'src/components/DepName/DepName.vue'

  export default {
    props: {
      user: {
        type: Object,
        default () {
          return {}
        }
      },
      isSuperAdmin: {
        type: Boolean,
        default: false
      }
    },
    components: {
      avatar,
      superAdminIdent,
      // depName
    },
    methods: {
      goToUserDetails () {
        this.$router.push({name: 'user', params: {id: this.user.getId()}});
      },
      hasContacts () {
        return this.user.getContacts() && this.user.getContacts().length;
      }
    },
    computed: {
      perms () {
        if (this.user) {
          return {
            // update: this.$store.state.users.user.checkUserPerm('PERM_USER_UPDATE', this.user._id)
          }
        } else {
          return {}
        }
      }
    },
    mounted () {
      // this.$store.dispatch('users/loadUserPerms', this.user._id);
    }
  };
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';
.user-list-detail {
  padding: 0 50px;

  &__header {
    display: grid;
    grid-template-columns: 1fr 290px;
    grid-column-gap: 15px;
    padding: 25px 0;
  }

  &__about-container {
    display: flex;
    align-items: center;
  }

  &__userpic-container {
    width: 100px;
  }

  &__about-text-container {
    margin-left: 25px;
    max-width: 275px;
  }

  &__buttons {
    justify-self: end;
    > .el-button {
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .el-button--primary {
      margin-left: 25px;
    }
  }

  &__names {
    margin-bottom: 4px;
    color: #333333;
    font-size: 20px;
    font-weight: 700;
    word-wrap: break-word;
  }

  &__specialities-label {
    margin-right: 10px;
    font-size: 14px;
    color: $secondary-font-color;
  }

  &__specialities-text {
    color: #333333;
  }

  .super-admin-ident {
    margin-bottom: 10px;
  }

  &__profile-section {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    padding: 25px 75px;
    margin: 0 -75px;
    border-top: 1px solid $light-border-color;
  }
}

.user-detail-info-block {

  &__label {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 700;
    color: #333333;
  }

  &__row {
    margin-bottom: 12px;
  }

  &__row-label {
    color: $secondary-font-color;
  }

  &__row-data {
    color: #333333;
    a {
      color: #333333;
    }
  }
}
</style>